const actionResponse = {
  methods: {
    actionResponse({success, message, type}) {
      this.showSuccess = success;
      this.showError = !success;
      if (!success) {
        this.errorMsg = message;
      }
      if (success && type) {
        this.successType = type;
      }
    },
  },
};

export { actionResponse };
